import { constructMetadata } from "../..";
import { metadataPrefix, metadataPostfix } from './MetadataDescription';
import {states} from '../../Location/states'
import { urlToArray } from '../../../../shared/utils';


const dataCvTest = 'data-cv-test';
const defaultMetadata = `${metadataPrefix} cars${metadataPostfix}`;

const carsRootTitle = 'Used Cars Online | Touchless Delivery Available';
const defaultPageTitle = 'Carvana | Buy Used Cars Online & Skip The Dealership';

const isRootCars = url => url.endsWith('/cars') || url.endsWith('/cars/');
const getPageTitle = link => isRootCars(link) ? carsRootTitle : defaultPageTitle;

const extractLocation = url => {
  const { urlArray, inInd } = urlToArray(url);

  return inInd >= 0 ?
      urlArray.slice(inInd + 1) : [];
}
const getGeolocationInfo = (pathname, location) => {
  const urlLocation = extractLocation(pathname);
  const confirmedState = location ? states.find(state => state === location.state) && urlLocation.length > 0 : null;
  return confirmedState ? location : null;
};


export const getDefaultMetaH1Title = (link, fullThumbnailPath = null) => {
  const [defaultCanonical] = link.split('/filters');
  const pageTitle = getPageTitle(link);
    return{
      metaData: defaultMetadata,
      pageTitle,
      defaultUrl: [{rel: "canonical", href:defaultCanonical}],
      ogUrl: link,
      imageUrl: fullThumbnailPath || 'https://carvanablobprod.blob.core.windows.net/vending-machine-landing-page-assets/open-graph.jpg',
      imageType:"image/jpeg",
      twitterCard:"summary_large_image",
      twitterSite: "@Carvana"
    };
  };

const getMetaArray = (pageDesc, metaData, seoTitle, shouldNoIndex) => {
  const meta = [
    {name:"description", content:metaData, [dataCvTest]:'Cv.Search.Metadata'},
    {property:"twitter:title", content:seoTitle, [dataCvTest]:'Cv.Search.TwitterOptimizedTitle'},
    {property:"twitter:description", content:metaData, [dataCvTest]:'Cv.Search.TwitterOptimizedDescription'},
    {property:"twitter:card", content:pageDesc.twitterCard, [dataCvTest]:'Cv.Search.TwitterOptimizedCard'},
    {property:"twitter:site", content:pageDesc.twitterSite, [dataCvTest]:'Cv.Search.TwitterOptimizedSite'},
    {property:"og:title", content:seoTitle, [dataCvTest]:'Cv.Search.OptimizedOGTitle'},
    {property:"og:description", content:metaData, [dataCvTest]:'Cv.Search.OptimizedOGMetaDescription'},
    {property:"og:type", content:'website', [dataCvTest]:'Cv.Search.OptimizedOGType'},
    {property:"og:image:url", content:pageDesc.imageUrl, [dataCvTest]:'Cv.Search.OptimizedOGImageUrl'},
    {property:"og:image:secure_url", content:pageDesc.imageUrl, [dataCvTest]:'Cv.Search.OptimizedOGSecureImageUrl'},
    {property:"og:image", content:pageDesc.imageUrl, [dataCvTest]:'Cv.Search.OptimizedOGImage'},
    {property:"og:image:type", content: pageDesc.imageType, [dataCvTest]:'Cv.Search.OgImageType'},
    {property:"og:site_name", content:"Carvana", [dataCvTest]:'Cv.Search.OptimizedOGSiteName'},
    {property:"og:url", content:pageDesc.ogUrl, [dataCvTest]:'Cv.Search.OptimizedOGUrl'}
];

  if(shouldNoIndex) meta.unshift({name:"robots", content:"noindex"});
  return meta;

};

const getDefaultMetaArray = (pageDesc, shouldNoIndex) => {
  const meta = [
    {name:"description", content:pageDesc.metaData, [dataCvTest]:'Cv.Search.DefaultMetadata'},
    {property:"twitter:title", content:pageDesc.pageTitle, [dataCvTest]:'Cv.Search.DefaultTwitterOptimizedTitle'},
    {property:"twitter:description", content:pageDesc.metaData, [dataCvTest]:'Cv.Search.DefaultTwitterOptimizedDescription'},
    {property:"twitter:card", content:pageDesc.twitterCard, [dataCvTest]:'Cv.Search.DefaultTwitterOptimizedCard'},
    {property:"twitter:site", content:pageDesc.twitterSite, [dataCvTest]:'Cv.Search.DefaultTwitterOptimizedSite'},
    {property:"og:title", content:pageDesc.pageTitle, [dataCvTest]:'Cv.Search.DefaultOptimizedOGTitle'},
    {property:"og:description", content:pageDesc.metaData, [dataCvTest]:'Cv.Search.DefaultOptimizedOGMetaDescription'},
    {property:"og:type", content:'website', [dataCvTest]:'Cv.Search.DefaultOptimizedOGType'},
    {property:"og:image:url", content:pageDesc.imageUrl, [dataCvTest]:'Cv.Search.DefaultOptimizedOGImageUrl'},
    {property:"og:image:secure_url", content:pageDesc.imageUrl, [dataCvTest]:'Cv.Search.DefaultOptimizedOGSecureImageUrl'} ,
    {property:"og:image", content:pageDesc.imageUrl, [dataCvTest]:'Cv.Search.DefaultOptimizedOGImage'},
    {property:"og:image:type", content: pageDesc.imageType, [dataCvTest]:'Cv.Search.DefaultOgImageType'},
    {property:"og:site_name", content:"Carvana", [dataCvTest]:'Cv.Search.DefaultOptimizedOGSiteName'},
    {property:"og:url", content:pageDesc.ogUrl, [dataCvTest]:'Cv.Search.DefaultOptimizedOGUrl'}
  ];

  if(shouldNoIndex) meta.unshift({name:"robots", content:"noindex"});
  return meta;
};

export const generateMetadata = (link, pathname, location, filters, cvnaid, thumbnail = null) =>{
    let fullThumbnailPath;
    if (thumbnail)  {
      fullThumbnailPath = thumbnail.startsWith('http') ? thumbnail : `https:${thumbnail}`;
    }
    const pageDesc =  getDefaultMetaH1Title(link, fullThumbnailPath);
    const locationInfo = getGeolocationInfo(pathname, location);
    const seoData = constructMetadata(filters, locationInfo);
    const {
      metaDescription: metaData,
      seoTitle,
    } = seoData;
    const pathHasFilters = (pathname.indexOf('/filters') > -1);
    const cvnaIdExists = cvnaid?.length > 0;
    const shouldNoIndex = (pathHasFilters || cvnaIdExists);
    const metaArray = getMetaArray(pageDesc, metaData, seoTitle, shouldNoIndex);
    const defaultMetaArray = getDefaultMetaArray(pageDesc, shouldNoIndex);

    if (thumbnail) {
      const thumbnailMeta = {property: "thumbnail", content: fullThumbnailPath};
      metaArray.push(thumbnailMeta)
      defaultMetaArray.push(thumbnailMeta)
    }

    return metaData
        ? {metadataArray: metaArray, title: seoTitle }
        : {metadataArray:defaultMetaArray, title: pageDesc.pageTitle };
};
